import ImageComponent from '#app/components/common/image-component'
import PlentyBody from '#app/components/typography/plenty-body'
import { getAttributeValue } from '#app/utils/attribute-util'
import { getFirstNonInstagramOrCustomMedia } from '#app/utils/media-utils'
import { type PlentyLineItem } from '#types/cart'
import { getVariantSize } from '../../utils'
import { BagPriceTag } from './bag-item-price-tag'

interface ProductBagCardProps {
	plentyLineItem: PlentyLineItem
}

const ProductBagCard = ({ plentyLineItem }: ProductBagCardProps) => {
	return (
		<>
			<div className="my-4">
				<div className="flex items-start gap-x-4">
					<ImageComponent
						size="thumbnail"
						src={getFirstNonInstagramOrCustomMedia(
							plentyLineItem.variant.images,
						)}
						alt="thumbnail-product"
						className="w-[82px] rounded-lg object-cover"
					/>

					<div className="grow">
						{/* Brand and name */}

						<PlentyBody size="xs">
							{getAttributeValue(plentyLineItem.variant, 'brand')}
						</PlentyBody>
						<PlentyBody size="sm">{plentyLineItem.name.en}</PlentyBody>
						{/* Colour and size */}
						<PlentyBody size="sm">
							{getAttributeValue(plentyLineItem.variant, 'color')}
						</PlentyBody>
						<PlentyBody size="sm">
							{getVariantSize(plentyLineItem.variant)}
						</PlentyBody>

						<BagPriceTag price={plentyLineItem.price} />
					</div>
				</div>
			</div>
		</>
	)
}

export default ProductBagCard
